import { render, staticRenderFns } from "./tradeData.vue?vue&type=template&id=460ae501&scoped=true&"
import script from "./tradeData.vue?vue&type=script&lang=js&"
export * from "./tradeData.vue?vue&type=script&lang=js&"
import style0 from "./tradeData.vue?vue&type=style&index=0&id=460ae501&lang=scss&scoped=true&"
import style1 from "./tradeData.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "460ae501",
  null
  
)

export default component.exports